import { WorldTile } from "../../engine/map/LevelMap";
import { TILE_TYPES } from "../../tiles";
import { RDisplay } from "../../ui/RotDisplay";
import Colors from "../Colors";

export enum FloorTypes {
  EMPTY,
  WALL,
  CHASM,
  OOB,
}

const VISIBLE_THEME = {
  wall: Colors.LIGHT_GRAY_1,
  floor: Colors.GRAY_2,
  bgs: [Colors.OFF_BLACK, Colors.OFF_BLACK],
};

export const drawTile = (
  display: RDisplay,
  x: number,
  y: number,
  tile: WorldTile<FloorTypes>
) => {
  const theme = VISIBLE_THEME;

  switch (tile.type) {
    case FloorTypes.EMPTY:
      display.draw(x, y, ".", theme.floor, theme.bgs[tile.z]);
      break;
    case FloorTypes.WALL:
      display.draw(x, y, TILE_TYPES.WALL, theme.wall, theme.bgs[tile.z]);
      break;
    case FloorTypes.OOB:
      display.draw(x, y, " ", Colors.OFF_BLACK, Colors.OFF_BLACK); //Draw oob tile for background color
      break;
  }
};
